<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" sm="12">
        <v-card>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-expand-all</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">集計費目情報編集</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-form ref="aggregate_form" v-model="valid" @submit.prevent>
              <v-text-field label="集計費目名" v-model="name" :rules="aggregateNameRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-checkbox v-model="aggregate_flg" :label="aggregate_label"></v-checkbox>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'AggregateMaster' }" depressed>キャンセル</v-btn>
            <v-btn color="primary" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleUpdate
        @updated="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import AggregateApi from "@/api/aggregate-api";
import CustomDialog from "@/components/custom_ui/CustomDialog";
import Rule from "@/validation/rules";

export default {
  name: "AggregateMasterEdit",
  components: {
    CustomDialog
  },
  data: () => ({
    loading: false,
    //フォームの項目
    name: "",

    aggregate_flg: false,
    aggregate_label: "労務費として扱う",

    // 更新ダイアログ
    dialogMaxWith: 500,
    dialogTitle: "",
    dialogItems: [],
    dialogDrawer: false,
    editId: null,

    // バリデーション
    valid: true,
    aggregateNameRules: Rule.aggregateNameRules,
  }),
  created() {
    this.initialize();
  },
  methods: {
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    initialize() {
      this.isLoading();
      this.aggregateApi = new AggregateApi();
      // 集計費目IDをルートパラメータから取得
      this.editId = this.$route.params.id;
      const promise = this.aggregateApi.info(this.editId);
      promise.then(response => {
        this.name = response.data.body.aggregate_info.name;
        this.aggregate_flg = response.data.body.aggregate_info.aggregate_flg;
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if(error.response.data.status == statusList.status.entityError) {
            this.$emit("error",error.response.data.message);
            this.$router.push({ name: "AggregateMaster" })
          } else {
            this.$emit("error",error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    //更新ボタン押下時
    checkDialog() {
      this.dialogTitle = "更新しますか？";
      this.dialogItems = [
        { name: "集計費目名", value: this.name },
        { name: "労務費として扱う", value: this.aggregate_flg ? '有効' : '無効' }
      ];
      this.dialogDrawer = true;
    },
    dialogCancel() {
      this.dialogDrawer = false;
    },
    //ダイアログ更新ボタン押下時
    submit() {
      if (this.$refs.aggregate_form.validate()) {
        this.isLoading();
        const params = {
          name: this.name,
          aggregate_flg: this.aggregate_flg ? '1' : '0'
        };
        const promise = this.aggregateApi.update(this.editId, params);
        promise.then(response => {
          this.$router.push({ name: 'AggregateMaster' });
          this.$emit("success", response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.dialogDrawer = false;
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      }
    }
  }
};
</script>
